import React from "react";
import { Box } from "@mui/material";

// gutter: a number (same on every screen) or an object per breakpoint, e.g. { xs: 8, md: 100 }
const FullWidthBreakout = ({ children, maxWidth = 1600, gutter = 24, sx }) => {
  const gutters = typeof gutter === "object" ? gutter : { xs: gutter };
  const widthFor = (px) => `min(calc(100vw - ${px * 2}px), ${maxWidth}px)`;

  const width = {};
  const marginLeft = {};
  Object.entries(gutters).forEach(([breakpoint, px]) => {
    width[breakpoint] = widthFor(px);
    marginLeft[breakpoint] = `calc(50% - ${widthFor(px)} / 2)`;
  });

  return <Box sx={{ width, marginLeft, ...sx }}>{children}</Box>;
};

export default FullWidthBreakout;
 